import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class TdisAlertService {

  constructor(private toastr: ToastrService) {
  }

  /** show toast */
  public show(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.clear();/*  */
    this.toastr.show(message, title, { closeButton: true, progressBar: true, positionClass: 'toast-top-center', timeOut: 1500 });
  }

  /** show successful toast */
  public success(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.clear();
    this.toastr.success(message, null, { closeButton: true, progressBar: true, positionClass: 'toast-top-center', timeOut: 1500 });
  }

  /** show error toast */
  public error(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.clear();
    if(message == undefined || message.length == 0 || message.trim().length == 0) return;
    this.toastr.error(message, null, { closeButton: true, progressBar: true, positionClass: 'toast-top-center', timeOut: 1500 });
  }

  /** show info toast */
  public info(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.clear();
    this.toastr.info(message, null, { closeButton: true, progressBar: true, positionClass: 'toast-top-center', timeOut: 1500 });
  }

  /** show warning toast */
  public warning(message?: string, title?: string, override?: Partial<IndividualConfig>) {
    this.toastr.clear();
    this.toastr.warning(message, null, { closeButton: true, progressBar: true, positionClass: 'toast-top-center', timeOut: 1500 });
  }

  public clear(toastId?: number): void {
    this.toastr.clear();
  }
}

